import * as React from 'react';
import Box from '@mui/material/Box';
import { Translate } from '../../../../../../../shared/LanguageService';
import Typography from '@mui/material/Typography';

type NoPhotographersAvailableProps = {};

export function NoPhotographersAvailable({}: NoPhotographersAvailableProps) {
    return (
        <Box
            component="section"
            sx={{
                padding: '20px 0'
            }}
        >
            <Typography
                variant="body1"
                sx={{
                    fontSize: '18px',
                    fontFamily: 'Roboto',
                    color: 'text.secondary',
                    textAlign: 'center',
                    padding: '20px 0'
                }}
            >
                {Translate('photographers/overview/text/no-available-photographers')}
            </Typography>
        </Box>
    );
}
